var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoColor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.399998 6.33579C0.312807 6.61819 0.239113 6.90651 0.179667 7.2H0.399998V10.8H0.179588C0.239047 11.0936 0.312768 11.3821 0.399998 11.6646V10.8H4V14.4H1.79426C2.40542 15.2165 3.15172 15.9259 4 16.4952V14.4H7.6V17.9088C7.86808 17.9512 8.14008 17.9818 8.41546 18H9.62399C10.1637 17.9643 10.6904 17.8811 11.2 17.7546V14.4H14.8V15.9246C15.3387 15.4745 15.824 14.9627 16.2452 14.4H14.8V10.8H17.8599C17.9776 10.2184 18.0395 9.61652 18.0395 9.00019C18.0395 8.38373 17.9776 7.78171 17.8598 7.2H14.8V3.6H16.2449C15.8238 3.0375 15.3385 2.5258 14.8 2.07575V3.6H11.2V0.245755C10.6885 0.118793 10.1598 0.035481 9.61808 0H8.42138C8.14397 0.0181678 7.86999 0.0488765 7.6 0.0915645V3.6H4V1.50522C3.15186 2.07438 2.40566 2.78369 1.79456 3.6H4V7.2H0.399998V6.33579ZM7.6 7.2V3.6H11.2V7.2H7.6ZM7.6 7.2V10.8H4V7.2H7.6ZM11.2 7.2H14.8V10.8H11.2V7.2ZM11.2 10.8V14.4H7.6V10.8H11.2Z",
    fill: "black",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoColor);
export default __webpack_public_path__ + "static/media/no-color.3d61a3ccc0b00ffd1bb34240670ef762.svg";
export { ForwardRef as ReactComponent };